<template>
  <div v-if="type" class="form-wrapper green-inputs mb-5">
    <div class="frame-dash-underlined mb-3">
      <div
        v-if="type != 'embeddednotdienst'"
        class="row pb-2 align-items-center"
      >
        <div class="col-12 col-md-6">
          <h2 class="h5 mb-0 text-uppercase headline">{{ sucheType }} SUCHEN:</h2>
        </div>
        <div class="col-12 col-md-6 text-md-end mt-4 mt-md-0">
          <div class="d-inline-block">
            <div class="input-group floating-icon pill ophover">
              <button
                class="form-control text-center fullpill"
                @click="resetFilters()"
                style="max-width: 14em !important"
              >
                <i class="fas fa-times text-red"></i> Alle Filter zurücksetzen
            </button>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="type == 'embeddednotdienst'"
        class="row pb-2 align-items-center"
      >
        <div class="col-6">
          <h5 class="mb-0 text-uppercase headline">{{ sucheType }} SUCHEN:</h5>
        </div>
        <div class="col-6 text-md-end">
          <div v-if="type == 'embeddednotdienst'" class="text-end">
            <div class="d-inline-block" style="max-width: 130px">
              <Logo />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row my-4">
      <div class="d-flex justify-content-between flex-wrap" style="gap: 10px">
        <div
          v-if="type == 'notdienste' || type == 'embeddednotdienst'"
          class="form-cell"
        >
          <div class="input-group withshadow twocorners green-input-text">
            <VueDatePicker
              locale="de"
              v-model="dateModel"
              ref="dateRef"
              cancelText="abbrechen"
              selectText="auswählen"
              model-type="yyyy-MM-dd"
              :clearable="false"
              :enable-time-picker="false"
              :format-locale="de"
              format="dd/MM/yyyy"
              :auto-apply="true"
              input-class-name="date-input"
              menu-class-name="date-menu"
            >
              <template
                #dp-input="{
                  value,
                  onInput,
                  onEnter,
                  onTab,
                  onClear,
                  onBlur,
                  onKeypress,
                  onPaste,
                  isMenuOpen,
                }"
              >
                <div class="input-group withshadow twocorners green-input-text">
                  <input
                    class="form-control unstyled"
                    style="max-width: 12em"
                    :value="value"
                  />
                  <span class="input-group-text">
                    <i class="fas fa-calendar-alt"></i>
                  </span>
                </div>
              </template>
            </VueDatePicker>
          </div>
        </div>

        <div
          v-if="type == 'notdienste' || type == 'embeddednotdienst'"
          class="form-cell"
        >
          <div class="input-group withshadow twocorners green-input-text">
            <VueDatePicker
              time-picker
              locale="de"
              v-model="hourModel"
              ref="hourRef"
              cancelText="abbrechen"
              selectText="auswählen"
              :value="dataStore.params.hour"
              model-type="HH:mm"
              :clearable="false"
              :auto-apply="true"
              :teleport="true"
              input-class-name="hour-input"
              menu-class-name="hour-menu"
            >
              <template
                #dp-input="{
                  value,
                  onInput,
                  onEnter,
                  onTab,
                  onClear,
                  onBlur,
                  onKeypress,
                  onPaste,
                  isMenuOpen,
                }"
              >
                <div class="input-group withshadow twocorners green-input-text">
                  <input
                    class="form-control unstyled"
                    style="max-width: 12em"
                    :value="value"
                    ref="dateRef"
                  />
                  <span class="input-group-text">
                    <i class="fas fa-clock"></i>
                  </span>
                </div>
              </template>
            </VueDatePicker>
          </div>
        </div>

        <div class="form-cell">
          <label for="Bezirk" class="form-label sr-only">Bezirk:</label>
          <select
            id="Bezirk"
            class="form-select green-arrow withshadow twocorners"
            v-model="bezirkModel"
            placeholder="Bezirk"
             @keyup.enter="callApi()"
          >
            <option v-for="op in bezirke" :value="op.code">
              {{ op.value }}
            </option>
          </select>
        </div>

        <div v-if="type == 'apotheken'" class="form-cell">
          <div class="input-group withshadow twocorners green-input-text">
            <label for="PLZ" class="form-label sr-only">PLZ:</label>
            <input
              class="form-control"
              style="max-width: 12em"
              @input="updateFormValue($event, 'zip')"
              @keyup.enter="callApi()"
              v-model="plzModel"
              placeholder="PLZ"
              id="PLZ"
            />
            <span class="input-group-text">
              <i class="fa fa-search"></i>
            </span>
          </div>
        </div>

        <div v-if="type == 'apotheken'" class="form-cell">
          <div class="input-group withshadow twocorners green-input-text">
            <label for="akname" class="form-label sr-only">Apotheken-Name oder Straße:</label>
            <input
              class="form-control"
              style="max-width: 12em"
              @input="updateFormValue($event, 's')"
              @keyup.enter="callApi()"
              v-model="searchModel"
              placeholder="Apotheken-Name oder Straße"
              id="akname"
            />
            <span class="input-group-text">
              <i class="fa fa-search"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row align-items-center">
      <div class="col-6">
        <div v-if="params.bezirk >= 0" class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            name="nachbarbezirke"
            id="nachbarbezirke"
            v-model="nachbarbezirke"
          />
          <label for="nachbarbezirke" class="form-check-label"
            >auch in benachbarten Bezirken suchen</label
          >
        </div>
      </div>
      <div class="col-12 text-start">
        <div class="d-inline-block">
          <div class="input-group floating-icon pill ophover">
            <button
              class="form-control text-center fullpill"
              @click="callApi()"
              style="max-width: 14em !important; min-width: 10em"
            >
             &nbsp;&nbsp;Suchen&nbsp;&nbsp;
          </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="type == 'notdienste'" class="text-red">
      Notdienste dauern jeweils 24 h von 9.00 Uhr bis 9.00 Uhr des
      darauffolgenden Tages.
    </div>
  </div>
</template>

<script setup>
import { ref, watch, reactive, defineProps, onMounted } from "vue";
import { storeToRefs } from "pinia";
import { useDataStore } from "@/store/";
import { debugLog } from "@/shared/utils";
import Logo from "@/components/Logo";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
const urlParams = new URLSearchParams(window.location.search);

const throttle = require("lodash/throttle");
const dataStore = useDataStore();
const loading = ref(false);
const { params, page, otherInfo } = storeToRefs(dataStore);
const { defaultType, resultsPerPage } = defineProps({
  defaultType: String,
  resultsPerPage: Number,
});

const type = ref(false);
const sucheType = ref("");
const typeCheckVal = ref(
  defaultType == "notdienste" || defaultType == "embeddednotdienst"
);
const nachbarbezirke = ref(false);

const results = {
  inside: {},
  outside: {},
  status: {
    insideNumTotal: null,
    outsideCallPage: 1,
    currentGroup: "inside", // inside, outside, or mixed - are the results currently showing from inside bezirk, outside, or mixed
  },
};

const optionsUp =
  typeof options !== "undefined"
    ? options
    : '{"bezirke":[{"code":"-1","value":"Alle Bezirke"},{"code":"7","value":"Charlottenburg"},{"code":"5","value":"Friedrichshain"},{"code":"23","value":"Hellersdorf"},{"code":"22","value":"Hohensch\u00f6nhausen"},{"code":"6","value":"Kreuzberg"},{"code":"16","value":"K\u00f6penick"},{"code":"17","value":"Lichtenberg"},{"code":"21","value":"Marzahn"},{"code":"1","value":"Mitte"},{"code":"14","value":"Neuk\u00f6lln"},{"code":"19","value":"Pankow"},{"code":"4","value":"Prenzlauer Berg"},{"code":"20","value":"Reinickendorf"},{"code":"11","value":"Sch\u00f6neberg"},{"code":"8","value":"Spandau"},{"code":"12","value":"Steglitz"},{"code":"13","value":"Tempelhof"},{"code":"2","value":"Tiergarten"},{"code":"15","value":"Treptow"},{"code":"3","value":"Wedding"},{"code":"18","value":"Wei\u00dfensee"},{"code":"9","value":"Wilmersdorf"},{"code":"10","value":"Zehlendorf"},{"code":"99","value":"au\u00dferhalb Berlin"}]}';
const { bezirke } = JSON.parse(optionsUp);
const dateRef = ref();
const hourRef = ref();

const today = new Date();
const defaultDate =
  today.getFullYear() +
  "-" +
  ("0" + (today.getMonth() + 1)).slice(-2) +
  "-" +
  ("0" + today.getDate()).slice(-2);
const defaultHour =
  (today.getHours() + "").padStart(2, "0") +
  ":" +
  (today.getMinutes() + "").padStart(2, "0");

const dateModel = ref(defaultDate);
const hourModel = ref(defaultHour);
const searchModel = ref("");
const plzModel = ref("");
const bezirkModel = ref(-1);

const emptyFieldParams = {
  s: "",
  zip: "",
  bezirk: urlParams.get("tx_akbnotdienst_notdienst[bezirk]") || "-1",
  datum: defaultDate,
  formDate: defaultDate,
  hour: defaultHour,
  mnb: "o",
};

dataStore.setParams({ ...emptyFieldParams });

// UPDATING DIFFERENT FORM VALUES - UPDATES PARAMS AND CALLS API
const updateFormValue = (e, key) => {
  if (key == "plz") {
    if (e.target.value.length == 5) {
      dataStore.setParams({ ...dataStore.params, [key]: e.target.value });
    }
  } else if (e) {
    dataStore.setParams({ ...dataStore.params, [key]: e.target.value });
  }
  dataStore.setParams({ ...dataStore.params, page: 1 });
  results.status = {
    insideNumTotal: null,
    outsideCallPage: 1,
    currentGroup: "inside",
  };
  //callApi();
};

// IF BEFORE 9AM, DATE NEEDS TO BE TRANSMITTED AS ONE DAY PREVIOUS. CALLED IN callApi()
const processDateParams = () => {
  const searchDate = new Date(dateModel.value + "T" + hourModel.value);
  const minDate = new Date(dateModel.value + "T09:00");
  if (searchDate < minDate) {
    searchDate.setDate(searchDate.getDate() - 1);
  }
  const dateParam =
    searchDate.getFullYear() +
    "-" +
    ("0" + (searchDate.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + searchDate.getDate()).slice(-2);
  dataStore.setParams({
    ...dataStore.params,
    datum: dateParam,
    formDate: dateRef?.value?.value,
    hour: hourRef?.value?.value,
  });
};

// PAGER
watch(
  page,
  (newVal, oldVal) => {
    if (newVal !== oldVal) {
      callApi();
    }
  }
);

// UPDATING VALUES
watch(nachbarbezirke, (newVal, oldVal) => {
  if (newVal) {
    dataStore.setParams({ ...dataStore.params, mnb: "x", page: 1 });
  } else {
    dataStore.setParams({ ...dataStore.params, mnb: "o", page: 1 });
  }
  updateFormValue(null, "nachbarbezirk");
});

watch(
  hourModel,
  (newVal, oldVal) => {
    hourRef.value = newVal;
    updateFormValue(null, "hour");
  },
  { deep: true }
);

watch(
  dateModel,
  (newVal, oldVal) => {
    dateRef.value = newVal;
    updateFormValue(null, "formDate");
  },
  { deep: true }
);

watch(
  bezirkModel,
  (newVal, oldVal) => {
    dataStore.setParams({ ...dataStore.params, bezirk: bezirkModel.value });
    //nachbarbezirke.value = false;
    updateFormValue(null, "bezirk");
  },
  { deep: true }
);

const resetFilters = () => {
  dataStore.setParams({ ...emptyFieldParams });
  dateModel.value = defaultDate;
  hourModel.value = defaultHour;
  bezirkModel.value = "-1";
  plzModel.value = "";
  searchModel.value = "";
  nachbarbezirke.value = false;
};

// MAIN API CALL
const callApi = throttle(() => {
  let options = {
    beforeStart: () => {
      dataStore.loading.apothekenfinder = true;
      debugLog(dataStore.params);
    },
    afterEnd: () => {
      dataStore.loading.apothekenfinder = false;
      document.querySelector(".apothekenfinder").scrollIntoView();
    },
    cache: false,
  };

  if (dataStore.params.mnb == "x") {
    options = {
      ...options,
      params: {
        mnb: "o",
      },
      beforeStart: () => {
        dataStore.loading.apothekenfinder = true;
      },
      afterEnd: () => {
        results.inside = dataStore.data;
        updateMergeStatus();
        dataStore.callApi({
          params: {
            mnb: "n",
            page: results.status.outsideCallPage,
          },
          afterEnd: () => {
            dataStore.loading.apothekenfinder = false;
            document.querySelector(".apothekenfinder").scrollIntoView();
            results.outside = dataStore.data;
            updateMergedResults();
            dataStore.setData(results.merged);
          },
          cache: false,
        });
      },
    };
  }
  processDateParams();
  dataStore.callApi(options);
}, 1000);

onMounted(() => {
  dataStore.otherInfo.apothekenfinder.type = defaultType;
  setType();
  if (defaultType !== "embeddednotdienst") {
    callApi();
  }
});

// FOR IN BEZIRK / ADDITIONAL BEZIRKS MERGING RESULTS
const updateMergeStatus = () => {
  const pageUp = dataStore.params.page || 1;
  if (!results.status.insideNumTotal)
    results.status.insideNumTotal = results.inside.num_total;
  const pagesOutside =
    (pageUp * resultsPerPage - (results.status.insideNumTotal || 0)) /
    resultsPerPage;
  results.status.currentGroup =
    pagesOutside < 0 ? "inside" : 1 > pagesOutside > 0 ? "mixed" : "outside";
  results.status.outsideCallPage = Math.max(1, Math.ceil(pagesOutside));
};

const updateMergedResults = () => {
  const data =
    results.status.currentGroup == "inside"
      ? results.inside.data
      : results.status.currentGroup == "outside"
      ? results.outside.data
      : [...results.inside.data, ...results.outside.data];
  const num_total = results.status.insideNumTotal + results.outside.num_total;
  const num_items =
    results.status.currentGroup == "inside"
      ? results.inside.num_items
      : results.status.currentGroup == "outside"
      ? results.outside.num_items
      : results.inside.num_items + results.outside.num_items;

  results.merged = {
    data: data,
    num_total: num_total,
    num_items: num_items,
    status: "success",
    merged: true,
    mergedGroups: {
      numInside: results.status.insideNumTotal,
      numOutside: results.outside.num_total,
    },
  };
  debugLog(results.merged);
};

// FOR TYPE (AKFINDER / NOTDIENST)
watch(
  dataStore,
  (newVal, oldVal) => {
    type.value = newVal.otherInfo.apothekenfinder.type;
    sucheType.value =
      type.value == "apotheken" ? "Apotheke" : "Notdienst Apotheke";
  },
  { deep: true }
);

const apiPointApothekenUp =
  typeof apiPointApotheken !== "undefined"
    ? apiPointApotheken
    : "http://akberlin:8888/patientinnen/notdienst?tx_apis_calluniplus%5Baction%5D=callUniplus&tx_apis_calluniplus%5Bcontroller%5D=X3&tx_apis_calluniplus%5Bpath%5D=apotheken%2Fsuche%2F&type=871&cHash=144fd227361070e7ffa76c951182f0d3";
const apiPointNotdienstUp =
  typeof apiPointNotdienst !== "undefined"
    ? apiPointNotdienst
    : "http://akberlin:8888/patientinnen/notdienst?tx_apis_calluniplus%5Baction%5D=callUniplus&tx_apis_calluniplus%5Bcontroller%5D=X3&tx_apis_calluniplus%5Bpath%5D=apotheken%2Fnotdienst%2F&type=871&cHash=0ab08d3acd1fac3635c967c2e7810ed4";

const setType = () => {
  const apiPoint =
    dataStore.otherInfo.apothekenfinder.type == "apotheken"
      ? apiPointApothekenUp
      : apiPointNotdienstUp;
  dataStore.setUrl(process.env.VUE_APP_API_BASE + apiPoint);
};
</script>
